document.addEventListener('DOMContentLoaded', () => {
  const inventoryElement = document.querySelector('#agnya-product-inventory');

  if (!inventoryElement) return;

  let inventoryData;

  try {
    inventoryData = JSON.parse(inventoryElement.textContent);
  } catch (error) {
    console.error('AGNYA inventory data could not be parsed.', error);
    return;
  }

  const updateInventoryMessage = () => {
    const message = document.querySelector('#agnya-inventory-message');
    if (!message) return;

    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (!variantInput) return;

    const variant = inventoryData[variantInput.value];

    if (!variant) return;

    const quantity = Number(variant.quantity);

    if (quantity > 0) {
      message.innerHTML = `
        <strong>
          ${
            quantity === 1
              ? '1 IN STOCK - READY TO SHIP'
              : `${quantity} IN STOCK - READY TO SHIP`
          }
        </strong>
        <span>Ships in 5–6 business days</span>
      `;

      message.hidden = false;
    } else {
      message.innerHTML = '';
      message.hidden = true;
    }
  };

  updateInventoryMessage();

  document.addEventListener('change', () => {
    setTimeout(updateInventoryMessage, 100);
  });
});